<script lang="ts">
	export let title: string;
	export let description: string;
	export let link: string;
	export let image: string;
	export let imagePosition: string = "center center";
</script>

<div class="service-box">
	<div class="service-img">
		<img class="img-responsive" src={image} alt="" style="object-position: {imagePosition}" />
	</div>
	<div class="service-box-info">
		<h3>{title}</h3>
		<p class="description">{description}</p>
		<p class="btn-wrapper">
			<a href={link} class="btn btn-outline btn-md remove-margin btn-square">Learn More</a>
		</p>
	</div>
</div>

<style lang="scss">
	.service-img img {
		height: 175px;
		object-fit: cover;
	}

	.service-box-info {
		height: 360px;
		display: flex;
		flex-direction: column;

		.description {
			flex-grow: 1;
		}

		.btn-wrapper {
			text-align: center;
		}
	}
</style>
